import React from "react";
import * as Icon from "react-feather";
import { BiCheckDouble, BiPaperPlane, BiSync } from "react-icons/bi";
import { BiCheckShield, BiGridAlt} from "react-icons/bi";
import { AiOutlineProject } from "react-icons/ai";
import { MdOutlineShoppingCart, MdOutlinePayment } from "react-icons/md";
import {
  FaCheck,
  FaFileInvoiceDollar,
  FaHelicopter,
  FaMinus,
  FaPlus,
  FaRegMoneyBillAlt,
  FaWrench,
  FaRegListAlt,
} from "react-icons/fa";
import { CgDebug } from "react-icons/cg";
import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { TbFileExport, TbFileCheck } from "react-icons/tb";
import { GrDocumentPerformance } from "react-icons/gr";
import { FaFileContract } from "react-icons/fa6";
import { PiCertificateBold } from "react-icons/pi";
import { TbFileInvoice } from "react-icons/tb";
import { FaMoneyBillTransfer } from "react-icons/fa6";
import { FaCashRegister } from "react-icons/fa6";

import { INVOICE_TYPE } from "../views/pages/finance/FinanceConsts";

const ICON_SIZE = 19;
const ICON_SIZE_SMALL = 14;
const navigationConfig = [
  /* {
    id: "finance",
    title: "Finance",
    icon: <FaRegMoneyBillAlt size={ICON_SIZE} />,
    permissions: ["Superuser", "Administrator", "Economy", "OrderContractor", "OrderApprover"],
    children: [ */
  /* {
    id: "financeIntentionsInvoice",
    title: "Záměry",
    permissions: ["Superuser", "Administrator"],
    children: [
      {
        id: "financeIntentionsInvoiceNew",
        title: "Přidat",
    
        icon: <FaPlus size={ICON_SIZE_SMALL} color="green" />,
        permissions: ["Superuser", "Administrator"],
        navLink: "/finance/invoice/detailNew/:filter",
        filterBase: "/finance/invoice/detailNew/" + INVOICE_TYPE.INTENTIONS
      },
      {
        id: "financeIntentionsInvoiceMy",
        title: "Moje",
    
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator"],
        navLink: "/finance/invoice/my/:filter",
        filterBase: "/finance/invoice/my/" + INVOICE_TYPE.INTENTIONS
      },
      {
        id: "financeIntentionsInvoiceApproving",
        title: "Schvalování",
    
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator"],
        navLink: "/finance/invoice/approving/:filter",
        filterBase: "/finance/invoice/approving/" + INVOICE_TYPE.INTENTIONS
      },
      {
        id: "financeIntentionsInvoiceView",
        title: "Přehled",
    
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator"],
        navLink: "/finance/invoice/view/:filter",
        filterBase: "/finance/invoice/view/" + INVOICE_TYPE.INTENTIONS
      },
    ]
  }, */
  {
    id: "home",
    title: "Rozcestník",

    icon: <BiGridAlt size={ICON_SIZE} />,
    permissions:  ["Superuser", "Administrator", "Economy", "OrderContractor", "OrderApprover", "AreaChief"],
    navLink: "/"
  }, 
    {
    id: "approval",
    title: "Doklady ke schválení",

    icon: <TbFileCheck size={ICON_SIZE} />,
    permissions:  ["Superuser", "Administrator", "AreaChief", "OrderApprover", "AdvanceInvoiceApprover", "InvoiceApprover"],
    navLink: "/finance/approval"
  }, 
  {
    id: "fund",
    title: "Rozpočty",

    icon: <FaRegMoneyBillAlt size={ICON_SIZE} />,
    permissions:  ["Superuser", "Administrator", "Economy", "OrderContractor", "OrderApprover", "AreaChief"],
    navLink: "/finance/fund",
  },
  {
    id: "financeIntention",
    title: "Záměry nákupu",
    icon: <MdOutlineShoppingCart size={ICON_SIZE} />,
    permissions: ["Superuser", "Administrator", "Economy", "OrderContractor", "OrderApprover", "AreaChief"],
    children: [
      {
        id: "financeIntentionNew",
        title: "Přidat",
        icon: <FaPlus size={ICON_SIZE_SMALL} color="green" />,
        permissions: ["Superuser", "Administrator", "Economy", "OrderContractor", "OrderApprover", "AreaChief"],
        navLink: "/finance/intention/detailNew"
      },
      {
        id: "financeIntentionMy",
        title: "Moje",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "Economy", "OrderContractor", "AreaChief"],
        navLink: "/finance/intention/my"
      },
      {
        id: "financeIntentionApproving",
        title: "Schvalování",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "OrderApprover", "AreaChief"],
        navLink: "/finance/intention/approving"
      },
      {
        id: "financeIntentionView",
        title: "Přehled",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "Economy"],
        navLink: "/finance/intention/view"
      },
      {
        id: "AreaChief",
        title: "Pohled pro náčelníky",
        type: "item",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "AreaChief"],
        navLink: "/finance/intention/AreaChief"
      },
    ]
  },
  {
    id: "publicProcurement",
    title: "Veřejné zakázky",

    icon: <PiCertificateBold size={ICON_SIZE} />,
    permissions: ["Superuser", "Administrator", "Economy", "OrderContractor", "OrderApprover", "AreaChief"],
    navLink: "/finance/publicProcurement"
  },
  {
    id: "financeContract",
    title: "Smlouvy",

    icon: <FaFileContract size={ICON_SIZE} />,
    permissions:  ["Superuser", "Administrator", "Economy", "OrderContractor", "OrderApprover", "AreaChief"],
    navLink: "/finance/contract",
  },
  {
    id: "financeOrder",
    title: "Objednávky",
    icon: <FaRegListAlt size={ICON_SIZE} />,
    permissions: [
      "Superuser",
      "Administrator",
      "Economy",
      "OrderContractor",
      "OrderApprover",
      "AreaChief",
    ],
    children: [
      {
        id: "financeOrderNew",
        title: "Přidat",
        icon: <FaPlus size={ICON_SIZE_SMALL} color="green" />,
        permissions: [
          "Superuser",
          "Administrator",
          "Economy",
          "OrderContractor",
          "OrderApprover",
        ],
        navLink: "/finance/order/detailNew",
      },
      {
        id: "financeOrderMy",
        title: "Moje",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: [
          "Superuser",
          "Administrator",
          "Economy",
          "OrderContractor",
        ],
        navLink: "/finance/order/my",
      },
      {
        id: "financeOrderApproving",
        title: "Schvalování",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "OrderApprover"],
        navLink: "/finance/order/approving",
      },
      {
        id: "financeOrderView",
        title: "Přehled",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "Economy"],
        navLink: "/finance/order/view",
      },
      {
        id: "AreaChief",
        title: "Pohled pro náčelníky",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "AreaChief"],
        navLink: "/finance/order/AreaChief",
      },
      {
        id: "financeOrderIsrs",
        title: "Předání k ISRS",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "Economy"],
        navLink: "/finance/order/isrs",
        onlyPrague: true,
      },
    ],
  },
  {
    id: "financeAdvanceInvoice",
    title: "Zálohové faktury",
    icon: <TbFileInvoice size={ICON_SIZE} />,
    permissions: [
      "Superuser",
      "Administrator",
      "Economy",
      "AdvanceInvoiceApprover",
      "AreaChief",
    ],
    children: [
      {
        id: "financeAdvanceInvoiceNew",
        title: "Přidat",
        icon: <FaPlus size={ICON_SIZE_SMALL} color="green" />,
        permissions: ["Superuser", "Administrator", "Economy"],
        navLink: "/finance/invoice/detailNew/:filter",
        filterBase: "/finance/invoice/detailNew/" + INVOICE_TYPE.ADVANCE,
      },
      {
        id: "financeAdvanceInvoiceMy",
        title: "Moje",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "Economy"],
        navLink: "/finance/invoice/my/:filter",
        filterBase: "/finance/invoice/my/" + INVOICE_TYPE.ADVANCE,
      },
      {
        id: "financeAdvanceInvoiceApproving",
        title: "Schvalování",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "AdvanceInvoiceApprover"],
        navLink: "/finance/invoice/approving/:filter",
        filterBase: "/finance/invoice/approving/" + INVOICE_TYPE.ADVANCE,
      },
      {
        id: "financeAdvanceInvoiceView",
        title: "Přehled",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "Economy"],
        navLink: "/finance/invoice/view/:filter",
        filterBase: "/finance/invoice/view/" + INVOICE_TYPE.ADVANCE,
      },
      {
        id: "AreaChief",
        title: "Pohled pro náčelníky",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "AreaChief"],
        navLink: "/finance/invoice/AreaChief/:filter",
        filterBase: "/finance/invoice/AreaChief/" + INVOICE_TYPE.ADVANCE,
      },
    ],
  },
  {
    id: "financeInvoice",
    title: "Faktury",
    icon: <FaFileInvoiceDollar size={ICON_SIZE} />,
    permissions: [
      "Superuser",
      "Administrator",
      "Economy",
      "InvoiceApprover",
      "AreaChief",
    ],
    children: [
      {
        id: "financeInvoiceNew",
        title: "Přidat",
        icon: <FaPlus size={ICON_SIZE_SMALL} color="green" />,
        permissions: ["Superuser", "Administrator", "Economy"],
        navLink: "/finance/invoice/detailNew/:filter",
        filterBase: "/finance/invoice/detailNew/" + INVOICE_TYPE.NORMAL,
      },
      {
        id: "financeInvoiceMy",
        title: "Moje",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "Economy"],
        navLink: "/finance/invoice/my/:filter",
        filterBase: "/finance/invoice/my/" + INVOICE_TYPE.NORMAL,
      },
      {
        id: "financeInvoiceApproving",
        title: "Schvalování",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "InvoiceApprover"],
        navLink: "/finance/invoice/approving/:filter",
        filterBase: "/finance/invoice/approving/" + INVOICE_TYPE.NORMAL,
      },
      {
        id: "financeInvoiceView",
        title: "Přehled",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "Economy"],
        navLink: "/finance/invoice/view/:filter",
        filterBase: "/finance/invoice/view/" + INVOICE_TYPE.NORMAL,
      },
      {
        id: "AreaChief",
        title: "Pohled pro náčelníky",
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "AreaChief"],
        navLink: "/finance/invoice/AreaChief/:filter",
        filterBase: "/finance/invoice/AreaChief/" + INVOICE_TYPE.NORMAL,
      },
    ],
  },
  /* {
    id: "financeCreditNoteInvoice",
    title: "Dobropisy",
    permissions: ["Superuser", "Administrator", "Economy", "AdvanceInvoiceApprover"],
    children: [
      {
        id: "financeCreditNoteInvoiceNew",
        title: "Přidat",
    
        icon: <FaPlus size={ICON_SIZE_SMALL} color="green" />,
        permissions: ["Superuser", "Administrator", "Economy"],
        navLink: "/finance/invoice/detailNew/:filter",
        filterBase: "/finance/invoice/detailNew/" + INVOICE_TYPE.CREDIT_NOTE
      },
      {
        id: "financeCreditNoteInvoiceMy",
        title: "Moje",
    
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "Economy"],
        navLink: "/finance/invoice/my/:filter",
        filterBase: "/finance/invoice/my/" + INVOICE_TYPE.CREDIT_NOTE
      },
      {
        id: "financeCreditNoteInvoiceApproving",
        title: "Schvalování",
    
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "AdvanceInvoiceApprover"],
        navLink: "/finance/invoice/approving/:filter",
        filterBase: "/finance/invoice/approving/" + INVOICE_TYPE.CREDIT_NOTE
      },
      {
        id: "financeCreditNoteInvoiceView",
        title: "Přehled",
    
        icon: <FaMinus size={ICON_SIZE_SMALL} />,
        permissions: ["Superuser", "Administrator", "Economy"],
        navLink: "/finance/invoice/view/:filter",
        filterBase: "/finance/invoice/view/" + INVOICE_TYPE.CREDIT_NOTE
      },
    ]
  }, */
  {
    id: "financeReceipt",
    title: "Pokladny",
    icon: <FaCashRegister size={ICON_SIZE} />,
    permissions: [
      "Superuser",
      "Administrator",
      "CashViewer",
      "CashContractor",
    ],
      children: [
        {
          id: "financeReceiptCashRegister",
          title: "Přehled pokladen",
          icon: <FaMinus size={ICON_SIZE_SMALL}/>,
          permissions: [
            "Superuser",
            "Administrator",
            "CashViewer",
            "CashContractor"
          ],
          navLink: "/finance/receipt/cashRegister",
        },
        {
          id: "financeReceiptCash",
          title: "Pokladní doklady",
          icon: <FaMinus size={ICON_SIZE_SMALL} />,
          permissions: [
            "Superuser",
            "Administrator",
            "CashViewer",
            "CashContractor"
          ],
          navLink: "/finance/receipt/cashReciept",
        },
      ],
  },
  {
    id: "financePaymentSupportingDocument",
    title: "Podklady k platbě",

    icon: <MdOutlinePayment size={ICON_SIZE} />,
    permissions:  ["SuperBanker"],
    regions: [4],
    navLink: "/finance/paymentSupportingDocument",
  },
  {
    id: "clients",
    title: "Kontakty",

    icon: <Icon.User size={ICON_SIZE} />,
    permissions: ["Superuser", "Administrator", "Economy", "OrderContractor"],
    navLink: "/office/contacts",
  },
  {
    id: "userExports",
    title: "Exporty",

    icon: <TbFileExport size={ICON_SIZE} />,
    permissions: ["Superuser", "Administrator", "Economy", "OrderContractor"],
    navLink: "/office/exports"
  },
  /* ]
}, */
  {
    id: "administration",
    title: "Administrace",
    icon: <MdOutlineAdminPanelSettings size={ICON_SIZE} />,
    permissions: ["Superuser", "Administrator", "SuperBanker"],
    children: [
      {
        id: "users",
        title: "Uživatelé",

        icon: <Icon.Users size={ICON_SIZE} />,
        permissions: ["Superuser", "Administrator"],
        navLink: "/administration/users",
      },
      {
        id: "newuser",
        title: "Nový uživatel",

        icon: <Icon.UserPlus size={ICON_SIZE} />,
        permissions: ["Superuser", "Administrator"],
        navLink: "/administration/newuser",
      },
      {
        id: "usergroups",
        title: "Skupiny a práva",

        icon: <BiCheckShield size={ICON_SIZE} />,
        permissions: ["Superuser", "Administrator"],
        navLink: "/administration/usergroups",
      },
      {
        id: "financeSettingsRules",
        title: "Schvalovací pravidla",

        icon: <BiCheckDouble size={ICON_SIZE} />,
        permissions: ["Superuser", "Administrator"],
        navLink: "/finance/settings/rules",
      },
      {
        id: "financePaymentOrder",
        title: "Bankovní příkazy",

        icon: <FaMoneyBillTransfer size={ICON_SIZE} />,
        permissions:  ["SuperBanker"],
        navLink: "/finance/paymentOrder",
      },
      {
        id: "data",
        title: "Číselníky",

        icon: <Icon.Database size={ICON_SIZE} />,
        permissions: ["Superuser", "Administrator"],
        navLink: "/office/data",
      },
      {
        id: "financeSettingsMoneySynchro",
        title: "Synchronizace s money",

        icon: <BiSync size={ICON_SIZE} />,
        permissions: ["Superuser", "Administrator"],
        navLink: "/finance/settings/moneySynchro",
      },
      {
        id: "other",
        title: "Ostatní",

        icon: <CgDebug size={ICON_SIZE} />,
        permissions: ["Superuser", "Administrator"],
        navLink: "/administration/other",
      },
    ],
  },
];

export default navigationConfig;
